var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaticIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#6C00F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3663 13.9322L12.6447 12.9086L7.47998 15.9794V22.0998L12.6447 25.16L17.8094 22.0998V12.5815L20.6753 10.8826L23.5411 12.5815V15.9794L20.6753 17.6783L18.9537 16.6548V19.3773L20.6753 20.4009L25.84 17.3407V11.2202L20.6753 8.16003L15.5105 11.2202V20.7386L12.6447 22.4375L9.77885 20.7386V17.3301L12.6447 15.6312L14.3663 16.6548V13.9322Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaticIcon);
export default __webpack_public_path__ + "static/media/matic-icon.4f539e577038c3b7571b60f019b9c974.svg";
export { ForwardRef as ReactComponent };